export default __webpack_public_path__ + "static/media/gallery-glass.750554cf.webp";